// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"511":"255b050c","807":"7d77a668","935":"b44f7fec"}[chunkId] + ".chunk.js";
};